import React from "react";
import {
    Box,
    useMediaQuery
} from "@mui/material";
import Divider from "@mui/material/Divider";
import theme from "../../theme/theme";

export interface SplitPageProps {
    childrenLeft?: React.ReactNode;
    childrenRight?: React.ReactNode;
    singlePage?: boolean
}

export function MaiSplitPage(
    {
        childrenLeft,
        childrenRight,
        singlePage = false,
    }: SplitPageProps) {
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: {
                    xs: 'column',
                    sm: 'column',
                    md: 'row',
                },
                height: '100%',
                width: '100%',
                overflowX: 'hidden',
                boxSizing: 'border-box',
            }}
        >
            {/* Linke Seite */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    width: isSmallScreen || singlePage ? '100%' : '50%',
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        maxHeight:'100%',
                        overflow: 'auto',
                    }}
                >
                    {childrenLeft}
                </Box>
            </Box>

            {!singlePage && (
                <>
                    {/* Divider zwischen linkem und rechtem Bereich */}
                    <Divider
                        orientation={isSmallScreen ? 'horizontal' : 'vertical'}
                        sx={{borderColor: isSmallScreen? theme.palette.text.primary: theme.palette.divider}}
                        flexItem
                    />

                    {/* Rechte Seite */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: 0,
                            width: isSmallScreen ? '100%' : '50%',
                        }}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                maxHeight:'100%',
                                overflow: 'auto',
                            }}
                        >
                            {childrenRight}
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    )
}